import React from "react";
import ReactDOM from "react-dom";
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { LocalizationProvider } from "@mui/lab";
import frLocale from "date-fns/locale/fr"
import { initSentrySession } from "../../service/SentryService";
import { CustomerProvider } from '../../customHooks/useCustomer';
import { Routing } from './Routing';
import { StyleProvider } from '../../customHooks/useStyleContext';
import ThemeWrapper from '../components/ThemeWrapper/ThemeWrapper';

const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}

window.addEventListener('resize', appHeight)
appHeight();

initSentrySession(typeof app_env !== 'undefined' ? app_env : 'dev');

const rootElement = document.getElementById("root");

const renderApp = () => {
    if (!rootElement) {
        return;
    }

    ReactDOM.render(
        <StyleProvider>
            <ThemeWrapper>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={frLocale}>
                    <CustomerProvider>
                        <Routing />
                    </CustomerProvider>
                </LocalizationProvider>
            </ThemeWrapper>
        </StyleProvider>
        ,
        rootElement
    );
};

renderApp();
